// src/components/Contact/ContactSection.jsx
import { useState, useEffect } from "react";
import emailjs from "@emailjs/browser";

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [canSubmit, setCanSubmit] = useState(true);

  const submitCooldown = 300000; // 5 phút

  useEffect(() => {
    const lastSubmit = localStorage.getItem("lastContactSubmit");
    if (lastSubmit) {
      const diff = Date.now() - parseInt(lastSubmit, 10);
      if (diff < submitCooldown) setCanSubmit(false);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!canSubmit) {
      alert("Bạn chỉ có thể gửi 1 lần trong 5 phút!");
      return;
    }

    if (!formData.name || !formData.email || !formData.message) {
      alert("Vui lòng điền đầy đủ thông tin!");
      return;
    }

    if (!validateEmail(formData.email)) {
      alert("Email không hợp lệ!");
      return;
    }

    // --- Tích hợp MailJS ---
    const emailParams = {
      formName: "Form Liên Hệ Từ Website Design24",
      fullName: formData.name,
      email: formData.email,
      message: formData.message,
    };

    emailjs
      .send(
        "service_3oo6e54", // ID service của bạn
        "template_los1h9c", // ID template
        emailParams,
        "Fg2TttehiRc-XVVCL" // Public key
      )
      .then((response) => {
        console.log("Email sent!", response.status, response.text);
        alert("Gửi tin nhắn thành công!");
        setFormData({ name: "", email: "", message: "" });
        setCanSubmit(false);
        localStorage.setItem("lastContactSubmit", Date.now().toString());

        // Reset quyền gửi sau 5 phút
        setTimeout(() => setCanSubmit(true), submitCooldown);
      })
      .catch((error) => {
        console.error("Email sending error:", error);
        alert("Gửi thất bại, vui lòng thử lại!");
      });
  };

  return (
    <section className="contact-section fix section-padding pt-0">
      <div className="container">
        <div className="contact-wrapper">
          <div className="row">
            {/* Bản đồ */}
            <div className="col-lg-6">
              <div className="map-items">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d9166.86685819123!2d105.7194016689872!3d10.006922661792713!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1zdHJ1bmcgdMOibSDhu6luZyBk4bulbmcgQ0FTVEEgY-G6p24gdGjGoQ!5e0!3m2!1svi!2s!4v1755681062424!5m2!1svi!2s"
                  style={{ border: 0, width: "100%", height: "450px" }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Google Map"
                />
              </div>
            </div>

            {/* Form liên hệ */}
            <div className="col-lg-6">
              <div className="contact-content">
                <div className="section-title text-center">
                  <h6>Liên hệ</h6>
                  <h2 data-wow-delay=".3s">Gửi tin nhắn cho chúng tôi</h2>
                </div>

                <form
                  onSubmit={handleSubmit}
                  className="contact-form-items mt-3 mt-md-0"
                >
                  <div className="row g-4">
                    <div className="col-lg-6">
                      <div className="form-clt">
                        <span>Họ và tên*</span>
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          placeholder="Họ và tên"
                          required
                        />
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form-clt">
                        <span>Email*</span>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="Email của bạn"
                          required
                        />
                      </div>
                    </div>

                    <div className="col-lg-12">
                      <div className="form-clt">
                        <span>Nội dung*</span>
                        <textarea
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                          placeholder="Nội dung tin nhắn"
                          required
                        />
                      </div>
                    </div>

                    <div className="col-lg-7">
                      <button
                        type="submit"
                        className="theme-btn"
                        disabled={!canSubmit}
                      >
                        Gửi tin nhắn
                      </button>
                    </div>
                  </div>
                </form>

                {!canSubmit && (
                  <p style={{ color: "red", marginTop: "10px" }}>
                    Bạn chỉ có thể gửi 1 lần trong 5 phút.
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
